import {
  SET_INVOICE_FILTER_VALUE,
  EXPAND_INVOICE_FILTER,
  APPLY_INVOICE_FILTERS_SUCCESS,
  RESTORE_INVOICE_FILTERS,
  CLEAR_ALL_INVOICE_FILTERS,
  CLEAR_INVOICE_FILTER,
  SET_INVOICE_FITLER_VALIDATION_ERROR,
  ENABLE_INVOICE_FILTER,
  DISABLE_INVOICE_FILTER,
  RESET_INVOICE_FILTERS
} from './InvoiceFiltersConstants';
import {
  isFilterValid,
  reformatDate,
  clearFilter
} from 'shared/helpers/filterValidationHelper';

const START_DATE = 'Start Date';
const END_DATE = 'End Date';

const validateAllFilters = filters =>
  filters.find(
    filter =>
      filter.filterValidationError !== '' &&
      filter.filterValidationError !== 'The start date should be selected'
  ) === undefined;

const expandInvoiceFilter = filter => ({ type: EXPAND_INVOICE_FILTER, filter });
const restoreInvoiceFilters = () => ({ type: RESTORE_INVOICE_FILTERS });
const clearAllInvoiceFilters = () => ({ type: CLEAR_ALL_INVOICE_FILTERS });
const applyFiltersSuccess = () => ({ type: APPLY_INVOICE_FILTERS_SUCCESS });
const resetInvoiceFilters = () => ({ type: RESET_INVOICE_FILTERS });
const enableInvoiceFilter = filterTitle => ({
  type: ENABLE_INVOICE_FILTER,
  filterTitle
});
const disableInvoiceFilter = filterTitle => ({
  type: DISABLE_INVOICE_FILTER,
  filterTitle
});

const setFilterValue = (filterKey, filterType, value) => ({
  type: SET_INVOICE_FILTER_VALUE,
  filterKey,
  filterType,
  value
});

const setFilterValidationError = (filterTitle, validationError) => ({
  type: SET_INVOICE_FITLER_VALIDATION_ERROR,
  filterTitle,
  validationError
});

const clearInvoiceFilter = filter => (dispatch, getState) => {
  const collapsedFilters = clearFilter(
    getState().invoiceFilters.tempFilters,
    filter
  );
  dispatch({ type: CLEAR_INVOICE_FILTER, collapsedFilters });
};

const validateFilter = filter => (dispatch, getState) => {
  const validationError = isFilterValid(filter);
  dispatch(setFilterValidationError(filter.title, validationError));
  const areFiltersValid = validateAllFilters(
    getState().invoiceFilters.tempFilters
  );
  return areFiltersValid;
};

const validateDateFilters = filterTitle => (dispatch, getState) => {
  const startDate = getState().invoiceFilters.tempFilters.find(
    filter => filter.title === START_DATE
  ).data.value;
  const endDate = getState().invoiceFilters.tempFilters.find(
    filter => filter.title === END_DATE
  ).data.value;
  const reformattedStartDate = reformatDate(startDate);
  const reformattedEndDate = reformatDate(endDate);
  if (parseInt(reformattedStartDate, 10) > parseInt(reformattedEndDate, 10)) {
    dispatch(
      setFilterValidationError(
        filterTitle,
        'The start date cannot come after the end date'
      )
    );
    return false;
  } else if (startDate === '') {
    dispatch(
      setFilterValidationError(END_DATE, 'The start date should be selected')
    );
    dispatch(disableInvoiceFilter(END_DATE));
  } else {
    dispatch(setFilterValidationError(START_DATE, ''));
    dispatch(setFilterValidationError(END_DATE, ''));
    dispatch(enableInvoiceFilter(END_DATE));
    return validateAllFilters(getState().invoiceFilters.tempFilters);
  }
};

const applyFilters = () => dispatch => dispatch(applyFiltersSuccess());

export {
  applyFilters,
  expandInvoiceFilter,
  clearInvoiceFilter,
  restoreInvoiceFilters,
  clearAllInvoiceFilters,
  setFilterValue,
  validateFilter,
  validateDateFilters,
  resetInvoiceFilters
};



// WEBPACK FOOTER //
// ./src/redux/invoiceFilters/InvoiceFiltersActions.js